<template>
	<div class="countdown-wrapper">
		<div class="countdown-box">
			<div class="counter-wrapper">
				<div class="counter-box">
					<div
						v-if="countDays && countDays > 0"
						class="counter-box-wrapper">
						<div class="counter-box-number" :style="[getStyle(), getColorStyle('days')]">{{ countDays }}</div>
						<div class="counter-box-title" :style="getColorStyle('days')">{{ this.options.daysLabel }}</div>
					</div>
					<div
						v-if="countHours && countHours > 0"
						class="counter-box-wrapper">
						<div class="counter-box-number" :style="[getStyle(), getColorStyle('hours')]">{{ countHours }}</div>
						<div class="counter-box-title" :style="getColorStyle('hours')">{{ this.options.hoursLabel }}</div>
					</div>
					<div class="counter-box-wrapper">
						<div class="counter-box-number" :style="[getStyle(), getColorStyle('minutes')]">{{ countMinutes }}</div>
						<div class="counter-box-title" :style="getColorStyle('minutes')">{{ this.options.minutesLabel }}</div>
					</div>
					<div class="counter-box-wrapper">
						<div class="counter-box-number" :style="[getStyle(), getColorStyle('seconds')]">{{ countSeconds }}</div>
						<div class="counter-box-title" :style="getColorStyle('seconds')">{{ this.options.secondsLabel }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import {
	getNodeStyle,
	getRgbaColor,
	// eslint-disable-next-line
} from '@/lib/helper';

export default {
	props: {
		options: Object,
		previewDevice: String,
		countDays: [Number, String],
		countHours: [Number, String],
		countMinutes: [Number, String],
		countSeconds: [Number, String],
	},
	data() {
		return {};
	},
	methods: {
		getStyle() {
			const device = this.previewDevice;
			const styles = [
				'font-size',
			];
			const style = getNodeStyle(this.options, styles, device);
			return style;
		},
		getColorStyle(field) {
			const style = {};
			let color = '#000';
			if (field === 'days') {
				color = this.options && this.options.daysColor
					? getRgbaColor(this.options.daysColor.rgb)
					: '#000';
				style.color = color;
			} else if (field === 'hours') {
				color = this.options && this.options.hoursColor
					? getRgbaColor(this.options.hoursColor.rgb)
					: '#000';
			} else if (field === 'minutes') {
				color = this.options && this.options.minutesColor
					? getRgbaColor(this.options.minutesColor.rgb)
					: '#000';
			} else if (field === 'seconds') {
				color = this.options && this.options.secondsColor
					? getRgbaColor(this.options.secondsColor.rgb)
					: '#000';
			}
			style.color = color;
			return style;
		},
	},
};
</script>

<style lang="scss" scoped>
.countdown-wrapper {
	margin: 0 auto;
	text-align: center;
	width: 100%;
}

@media only screen and (max-width: 768px) {
	.countdown-wrapper {
		width: 100%;
	}
}


.countdown-box {
	padding: 16px;
}

.countdown-box .counter-heading {
	text-align: center;
	font-size: 12px;
}

.countdown-box .counter-footer {
	text-align: center;
	font-size: 10px;
}

.countdown-box .counter-box {
	display: table;
	padding: 16px 0 16px;
	margin: auto;
	width: auto;
}

.countdown-box .counter-box .counter-box-wrapper {
	display:table-cell;
	text-align:center;
	position:relative;
	padding: 0 .5rem;
}

.countdown-box .counter-box .counter-box-wrapper:after {
	// content: ':';
	content: '';
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	right: -1px;
	font-size: 24px
}

.countdown-box .counter-box .counter-box-wrapper:last-child:after {
	content: ''
}

.countdown-box .counter-box .counter-box-number {
	// font-size: 300px;
	font-weight: 600;
}

.countdown-box .counter-box .counter-box-title {
	font-size: 12px;
}

</style>
